import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

const methodCheckSchema = z.object({
  id: z.string(),
  configured: z.boolean(),
  available: z.boolean(),
});

const exchangeCartridgeStatusSchema = z.union([
  z.object({ installed: z.literal(false) }),
  z.object({ installed: z.literal(true), error: z.string() }),
  z.object({
    installed: z.literal(true),
    error: z.null(),
    version: z.string(),
    client: z.enum(["trusted", "mismatch", "unset"]),
    missingAttributes: z.array(z.string()),
    redoPaymentMethodIds: z.array(z.string()),
  }),
]);

const exchangeOrderSiteCheckSchema = z.discriminatedUnion("ok", [
  z.object({
    ok: z.literal(true),
    siteId: z.string(),
    defaultShippingMethodId: z.string().nullable(),
    fallbackShippingMethodId: z.string().nullable(),
    shippingMethodIds: z.array(z.string()),
    paymentMethodIds: z.array(z.string()),
    shippingMethod: methodCheckSchema.nullable(),
    paymentMethod: methodCheckSchema,
    cartridge: z.object({
      ready: z.boolean(),
      problem: z.string().nullable(),
      status: exchangeCartridgeStatusSchema,
    }),
  }),
  z.object({ ok: z.literal(false), siteId: z.string(), error: z.string() }),
]);

export type ExchangeOrderSiteCheck = z.infer<
  typeof exchangeOrderSiteCheckSchema
>;

export const verifyCommerceCloudExchangeOrderMethods = {
  name: "verifyCommerceCloudExchangeOrderMethods" as const,
  input: z.object({ integrationId: commerceCloudIntegrationId }),
  output: z.discriminatedUnion("ok", [
    z.object({
      ok: z.literal(true),
      sites: z.array(exchangeOrderSiteCheckSchema),
    }),
    z.object({ ok: z.literal(false), error: z.string() }),
  ]),
};

export type VerifyCommerceCloudExchangeOrderMethodsOutput = z.infer<
  typeof verifyCommerceCloudExchangeOrderMethods.output
>;
